import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { environment } from '../../../environments/environment';
import { InspectionStatuses, InspectionTypes as ITPS } from '../shared/models/Inspection';
import * as Constants from "../../models/Constants";
import { NgxSpinnerService } from 'ngx-spinner';
import { InspectionService } from '../shared/services/inspection.service';
import { AlertService } from '../../shared/services/alert.service';

@Component({
  selector: 'app-legacy-data-capa',
  templateUrl: './legacy-data-capa.component.html',
  styleUrls: ['./legacy-data-capa.component.css']
})
export class LegacyDataCapaComponent implements OnInit {

  public currentInspectionType : string;
  public inspectionListLink: string;
  public currentInspectionName: string;
  constructor(private activatedRoute: ActivatedRoute, private spinner: NgxSpinnerService, private inspectionService: InspectionService, 
    private alertService: AlertService, private router: Router) { }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(params => {
      this.currentInspectionType = params['inspectionTypeCode'];
      this.inspectionListLink = this.currentInspectionType == 'LOCALGMP' ? "/inspections/localGMP/list/LOCALGMP" :
        `/inspections/abroadCGMP/list/${this.currentInspectionType}`;
      this.currentInspectionName = this.currentInspectionType == 'LOCALGMP' ? ITPS.codeToName(ITPS.NEW_LOCAL_GMP_INSPECTION) : 
        this.currentInspectionType == 'ABROADCGMP' ? ITPS.codeToName(ITPS.NEW_ABROAD_CGMP_INSPECTION) : ITPS.codeToName(ITPS.NEW_ABROAD_CGMP_INSPECTION_WAIVER);
    });
  }

  onSubmit(event) {
    this.spinner.show();
    let inspectionId = event.facilities.facility.inspectionID;
    this.inspectionService.submitCapa(inspectionId).subscribe(resp => {
      this.spinner.hide();
      if(resp){
        this.alertService.success("CAPA Plan Submitted Successfully!");
        this.router.navigate([this.inspectionListLink]);
      }else {
        this.alertService.error("CAPA Plan Couldn't be Submitted, Try again!");
      }
    }, error => {
      console.log(error)
      this.spinner.hide();
      this.alertService.error("CAPA Plan Couldn't be Submitted, Try again!");
    })
  }

  localGmpFields = [
    {
      type: "steps",
        fieldGroup: [
          {
            key: "facilties",
            fieldGroupClassName: "row",
            templateOptions: { title: "Facilities" },
            fieldGroup: [
              {
                key: "facility",
                type: "lookup",
                className: "col-md-6",
                templateOptions: {
                  label: "Facilities",
                  required: true,
                  multiple: false,
                  prefetch: true,
                  searchable: false,
                  minLengthTerm: 0,
  
                  responseFn: (res) => {         
                    return {
                      name: res.name,
                      id: res.id,
                      inspectionID: res.inspectionID,
                      isLegacyData: res.isLegacyData,
                      inspectionStatusCode: res.inspectionStatusCode,
                    };
                  },
                  list: {
                    method: "get",
                    url: (term) =>
                      `${environment.baseUrl}/Inspection/LocalGMPInspection/LegacyCapa/GetFacilities`,
                    responseFn: (res) => {
                      let index = 0;
                      res.forEach((element) => {
                        res[index].name = res[index].manufacturerName;
                        ++index;
                      });
                      return res;
                    },
                  },
                },
                validators: {
                  validation: ["legacy"],
                },
                hideExpression: (
                  model: any,
                  formState: any,
                  field: FormlyFieldConfig
                ) => {
                  return false;
                },
                hooks: {
                  onInit: (field: FormlyFieldConfig) => {
                    console.log("inside hook");
                    field.form.get("facility").valueChanges.subscribe((data) => {
                      this.valueChanged(field);
                    });
                  },
                },
              },
              {
                type: 'edit-anchor',
                key: 'editApplication',
                className: "col-md-6",
                templateOptions: {
                  inspectionType: 'NLGI'
                },
                hideExpression: (
                  model: any,
                  formState: any,
                  field: FormlyFieldConfig
                ) => {
                  return model.facility?.isLegacyData && model.facility?.inspectionStatusCode != InspectionStatuses.LEGACY_DATA_EDITED ? false: true;
                },
              },
            ],
          },
          {
            key: "capaAttachment",
            templateOptions: {
              title: "CAPA Attachment",
              description: "",
              icon: "fa fa-info-circle",
            },
            fieldGroup: [
              {
                key: "documents",
                type: "upload-list",
  
                templateOptions: {
                  required: true,
                  items: [],
                  dependsOnField: "facilities.facility",
                  dataSourceFn: (param) => {
                    return {
                      url: `/DocumentRef/GetByName/${Constants.CAPA_DOC_NAME}`,
                      method: 'get'
                    };
                  },
                  extraData: {
                    urlParameter: "",
                    originalFileName: "-",
                  },
                },
              },
            ],
          },
        ]
    } 
  ]

  abroadCgmpFields = [
    {
      type: "steps",
        fieldGroup: [
          {
            key: "facilities",
            fieldGroupClassName: "row",
            templateOptions: { title: "Facilities" },
            fieldGroup: [
              {
                key: "facility",
                type: "lookup",
                className: "col-md-6",
                templateOptions: {
                  label: "Facilities",
                  required: true,
                  multiple: false,
                  prefetch: true,
                  searchable: false,
                  minLengthTerm: 0,
  
                  responseFn: (res) => {             
                    return {
                      name: res.name,
                      id: res.id,
                      inspectionID: res.inspectionID,
                      isLegacyData: res.isLegacyData,
                      inspectionStatusCode: res.inspectionStatusCode,
                    };
                  },
                  list: {
                    method: "get",
                    url: (term) =>
                      `${environment.baseUrl}/Inspection/AbroadCGMPInspection/LegacyCapa/GetAbroadFacilities`,
                    responseFn: (res) => {
                      let index = 0;
                      res.forEach((element) => {
                        res[index].name = res[index].manufacturerName;
                        ++index;
                      });
                      return res;
                    },
                  },
                },
                validators: {
                  validation: ["legacy"],
                },
                hideExpression: (
                  model: any,
                  formState: any,
                  field: FormlyFieldConfig
                ) => {
                  return false;
                },
                hooks: {
                  onInit: (field: FormlyFieldConfig) => {
                    console.log("inside hook");
                    field.form.get("facility").valueChanges.subscribe((data) => {
                      this.valueChanged(field);
                    });
                  },
                },
              },
              {
                type: 'edit-anchor',
                key: 'editApplication',
                className: "col-md-6",
                templateOptions: {
                  inspectionType: 'NACI'
                },
                hideExpression: (
                  model: any,
                  formState: any,
                  field: FormlyFieldConfig
                ) => {
                  return model.facility?.isLegacyData && model.facility?.inspectionStatusCode != InspectionStatuses.LEGACY_DATA_EDITED ? false: true;
                },
              },
            ],
          },
          {
            key: "capaAttachment",
            templateOptions: {
              title: "CAPA Attachment",
              description: "",
              icon: "fa fa-info-circle",
            },
            fieldGroup: [
              {
                key: "documents",
                type: "upload-list",
  
                templateOptions: {
                  required: true,
                  items: [],
                  dependsOnField: "facilities.facility",
                  dataSourceFn: (param) => {
                    return {
                      url: `/DocumentRef/GetByName/${Constants.CAPA_DOC_NAME}`,
                      method: 'get'
                    };
                  },
                  extraData: {
                    urlParameter: "",
                    originalFileName: "-",
                  },
                },
              },
            ],
          },
        ]
    } 
  ]

  waiverCgmpFields = [
    {
      type: "steps",
        fieldGroup: [
          {
            key: "facilties",
            fieldGroupClassName: "row",
            templateOptions: { title: "Facilities" },
            fieldGroup: [
              {
                key: "facility",
                type: "lookup",
                className: "col-md-6",
                templateOptions: {
                  label: "Facilities",
                  required: true,
                  multiple: false,
                  prefetch: true,
                  searchable: false,
                  minLengthTerm: 0,
  
                  responseFn: (res) => {             
                    return {
                      name: res.name,
                      id: res.id,
                      inspectionID: res.inspectionID,
                      isLegacyData: res.isLegacyData,
                      inspectionStatusCode: res.inspectionStatusCode,
                    };
                  },
                  list: {
                    method: "get",
                    url: (term) =>
                      `${environment.baseUrl}/Inspection/AbroadCGMPInspection/Waiver/LegacyCapa/GetAbroadFacilities`,
                    responseFn: (res) => {
                      let index = 0;
                      res.forEach((element) => {
                        res[index].name = res[index].manufacturerName;
                        ++index;
                      });
                      return res;
                    },
                  },
                },
                validators: {
                  validation: ["legacy"],
                },
                hideExpression: (
                  model: any,
                  formState: any,
                  field: FormlyFieldConfig
                ) => {
                  return false;
                },
                hooks: {
                  onInit: (field: FormlyFieldConfig) => {
                    console.log("inside hook");
                    field.form.get("facility").valueChanges.subscribe((data) => {
                      this.valueChanged(field);
                    });
                  },
                },
              },
              {
                type: 'edit-anchor',
                key: 'editApplication',
                className: "col-md-6",
                templateOptions: {
                  inspectionType: 'NACIW'
                },
                hideExpression: (
                  model: any,
                  formState: any,
                  field: FormlyFieldConfig
                ) => {
                  return model.facility?.isLegacyData && model.facility?.inspectionStatusCode != InspectionStatuses.LEGACY_DATA_EDITED ? false: true;
                },
              },
            ],
          },
          {
            key: "capaAttachment",
            templateOptions: {
              title: "CAPA Attachment",
              description: "",
              icon: "fa fa-info-circle",
            },
            fieldGroup: [
              {
                key: "documents",
                type: "upload-list",
  
                templateOptions: {
                  required: true,
                  items: [],
                  dependsOnField: "facilities.facility",
                  dataSourceFn: (param) => {
                    return {
                      url: `/DocumentRef/GetByName/${Constants.CAPA_DOC_NAME}`,
                      method: 'get'
                    };
                  },
                  extraData: {
                    urlParameter: "",
                    originalFileName: "-",
                  },
                },
              },
            ],
          },
        ]
    } 
  ]

  valueChanged(field: FormlyFieldConfig) {}
}
